import { DatePipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { NotificationService } from './services/notification.service';

@NgModule()
export class NotificationCoreModule {

    static forRoot(): ModuleWithProviders<NotificationCoreModule> {
        return {
            ngModule: NotificationCoreModule,
            providers: [
                NotificationService,
                DatePipe
            ]
        };
    }
}
